import {signal, Signal} from "../../fjsc/src/signals.ts";
import {SearchResult} from "../models/SearchResult.ts";
import {AnyElement, create, ifjs, signalMap, StringOrSignal} from "../../fjsc/src/f2.ts";
import {getImageUrl, target} from "../functions/templates.ts";
import {MediaFileType} from "../enums/MediaFileType.ts";
import {RequestableImageSize} from "./requestableImageSize.ts";
import {navigate} from "../routing/Router.ts";
import {FJSC} from "../../fjsc";
import {InputType} from "../../fjsc/src/Types.ts";
import {Generics} from "./generics.ts";

export class Search {
    static results(results: Signal<SearchResult[]>, title: StringOrSignal) {
        return create("div")
            .classes("flex-v", "fjsc-fill-parent")
            .children(
                create("div")
                    .classes("flex", "center-items")
                    .children(
                        Generics.heading(2, title),
                    ).build(),
                signalMap(results, create("div").classes("flex", "search-results", "scroll-shadows"), Search.result)
            ).build();
    }

    private static result(result: SearchResult) {
        let elementReference: AnyElement;
        let display = result.display;
        if (result.display.length > 50) {
            display = result.display.substring(0, 50) + "...";
        }
        let subtitle = result.subtitle;
        if (subtitle && subtitle.length > 50) {
            subtitle = subtitle.substring(0, 50) + "...";
        }

        const image = signal("/images/LOGO.svg");
        const typeMap = new Map([
            ["track", MediaFileType.trackCover],
            ["album", MediaFileType.albumCover]
        ]);
        if (result.hasImage) {
            image.value = getImageUrl(typeMap.get(result.type)!, result.id, RequestableImageSize.s50);
        }

        elementReference = create("button")
            .classes("fjsc", "search-result", "space-outwards", "padded", "flex", "noflexwrap", result.exactMatch ? "exact" : "partial")
            .onclick(async () => {
                navigate(result.url);
            })
            .children(
                create("div")
                    .classes("flex", "noflexwrap")
                    .children(
                        create("span")
                            .classes("search-result-image")
                            .children(
                                create("img")
                                    .src(image)
                                    .build()
                            ).build(),
                        create("div")
                            .classes("flex-v", "nogap", "search-result-text")
                            .children(
                                create("div")
                                    .classes("flex", "center-items", "noflexwrap")
                                    .children(
                                        create("span")
                                            .classes("search-result-display")
                                            .text(display)
                                            .build(),
                                    ).build(),
                                create("span")
                                    .classes("search-result-subtitle", "text-xsmall")
                                    .text(subtitle)
                                    .build(),
                            ).build(),
                    ).build(),
                create("span")
                    .classes("search-result-type", "hideOnSmallBreakpoint", result.type)
                    .text(result.type)
                    .build()
            ).build();
        return elementReference;
    }

    static searchInput(search: Signal<string>) {
        let timeout: number|Timer|null;

        return create("div")
            .classes("flex", "relative", "search-input-container")
            .children(
                FJSC.input<string>({
                    type: InputType.text,
                    name: "search",
                    value: search,
                    placeholder: "Search",
                    classes: ["search-input"],
                    onkeydown: (e) => {
                        if (timeout) {
                            clearTimeout(timeout);
                        }
                        timeout = setTimeout(() => {
                            search.value = target(e).value;
                        }, 200);
                    }
                }),
                Generics.icon("search", ["search-icon"]),
                Generics.iconButton("close", ["clear-icon"], () => {
                    search.value = "";
                }),
            ).build();
    }
}